export default __webpack_public_path__ + "static/media/018-gift-1.bfd83978.png";